import { RouteComponentProps } from "@reach/router"
import { ApiError, DocumentTitleOverride } from "@shared/primitive-components"
import { ScreenContentWithContext } from "../../components/ScreenContentWithContext"
import { usePolicyAndFleet } from "../../contexts"
import { useFleetInsights } from "../../api/insights/fleet/useGetPeriods"
import { SummaryChartCard, PrevPolicyDropdown } from "../components"
import {
  RebateChartComponent,
  RebateChartSummaryComponent,
  RebatesSummaryInfoBar,
  StatList,
} from "../components/RebateSummaryComponents"
import { LOSS_RATIO_TARGET, LOSS_RATIO_TARGET_V2 } from "../const"
import { usePolicyAccessCapabilities } from "../../hooks"
import { useRebateSummary } from "../../api/rebates/useGetRebateSummary"

export const REBATES_SUMMARY_ROOT_DTI = `rebates_summary_root`

export const RebatesSummary: React.FC<RouteComponentProps> = () => {
  const { policy } = usePolicyAndFleet()
  const { apiErrored: errRebates, data: summary, loading: rebatesLoading } = useRebateSummary()
  const { isRebateV2Policy } = usePolicyAccessCapabilities()
  const target = isRebateV2Policy ? LOSS_RATIO_TARGET_V2 : LOSS_RATIO_TARGET
  const { data, loading } = useFleetInsights()
  const score = data?.total?.safetyScore ? Math.round(data?.total?.safetyScore) : null
  if (errRebates) return <ApiError />
  return (
    <>
      <DocumentTitleOverride>Flock Motor | Rebates</DocumentTitleOverride>
      <ScreenContentWithContext
        title="Your rebates"
        dataTestIds={{ root: REBATES_SUMMARY_ROOT_DTI }}
        PreviousPolicyDropdown={<PrevPolicyDropdown />}
      >
        <SummaryChartCard summary={RebateChartSummaryComponent} chart={RebateChartComponent} />
        <StatList
          providerLoading={rebatesLoading || loading}
          fleetScore={{
            value: score!,
            threshold: summary?.safetyScoreThreshold!,
          }}
          lossRatio={{
            value: policy.grossEarnedLossRatio,
            threshold: target,
          }}
          mileage={{
            value: summary?.accumulatedMileage!,
            threshold: summary?.accumulatedExpectedMileage!,
          }}
        />
        <RebatesSummaryInfoBar />
      </ScreenContentWithContext>
    </>
  )
}
